import { render, staticRenderFns } from "./PrepareMaterial.vue?vue&type=template&id=dec8f8e2&scoped=true&"
import script from "./PrepareMaterial.vue?vue&type=script&lang=js&"
export * from "./PrepareMaterial.vue?vue&type=script&lang=js&"
import style0 from "./PrepareMaterial.vue?vue&type=style&index=0&id=dec8f8e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec8f8e2",
  null
  
)

export default component.exports